"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAutoFields = void 0;
function removeAutoFields(doc) {
  var clone = __assign({}, doc);
  delete clone._id;
  delete clone.id;
  delete clone.created;
  delete clone.updated;
  return clone;
}
exports.removeAutoFields = removeAutoFields;